import { createApi } from "@reduxjs/toolkit/query/react";
import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axios from "axios";
import type { AxiosRequestConfig, AxiosError } from "axios";
import fileDownload from "js-file-download";
import { Auth } from "aws-amplify";

import {
  Group,
  DependenceCharacter,
  ErrorData,
  NgName,
  DependenceCharacterUpload,
  DependenceCharacterUpdateResult,
  NgNamesUpload,
  NgNamesUpdateResult,
  Notice,
  Message,
  NoticeUpdate,
  HoldingsInfo,
  MerchantTypeReference,
  MerchantTypeResistUpdate,
  MerchantType,
  MerchantTypeResist,
  MerchantTypeResult,
  Division,
  StatusMessage,
  HoldingsRegister,
  HoldingsRegisterResult,
  HoldingsUpdateInfo,
  HoldingsUpdate,
  // HoldingsUpdateAffiliatedStoreCompany,
  IndustryConversionReference,
  IndustryConversionRequest,
  RateAdjustmentCaseSearchResponse,
  RateAdjustmentCaseSearchRequest,
  RateAdjustmentCaseContentResponse,
  RateAdjustmentCaseContentRequest,

  //ユーザ関連
  UsersSearchResponse,
  UsersSearchRequest,
  UserCreateRequest,
  UserUpdateRequest,
  UsersUpdateRequest,
  AuthResponse,

  // hd
  HoldingsSearchRequest,
  CompanyNamesSearchResponse,
  ReferenceGroupNamesSearchResponse,
  ReferenceGroupNamesSearchRequest,
  HoldingsAffiliatedCompany,
  HoldingsAffiliatedCompanyRegister,
  HoldingsAffiliatedCompanyRequest,

  // gw
  GatewaySearchResponse,
  GatewaySearchRequest,
  GatewayCompaniesContracts,
  GatewayCompaniesContractsResult,
  GatewayRegister,
  GatewayRegisterResult,
  GatewayCompaniesContractsUpdateInfo,
  GatewayCompaniesContractsInfoItem,
  GatewayCompaniesInfo,
  GatewayContract,
  GatewayUpdate,
  GatewayUpdateResult,
  TouristIndustries,
  TouristIndustriesItem,
  TouristIndustriesUpload,
  TouristIndustriesUpdateResult,
  CommercialIndustries,
  IndustryConversionsRequest,
  IndustryConversionsResult,
  IndustryConversion,
  IndustryConversionsUpdate,

  // 共通
  CompanyTypeRole,
  CodeList,
  UserDeleteRequest,
  ApplicationForms,
  CompanyNamesSearchRequest,
  MerchantsInclusionApplicationUpload,
  CompanyCodeCheck,
  MerchantAlternativeDirectApplication,
  MerchantsDirectApplicationResponse,
  MerchantsDirectApplicationRequest,
  PriorPayoutCreditCardMerchantNumbersResponse,
  PriorPayoutCreditCardMerchantNumbersRequest,
  CreditCardExamination,
  CreditCardExaminationsRequest,
  ComprehensiveCompanySearchResponse,
  ComprehensiveCompanySearchRequest,
  DirectCompanyResponse,
  CorpInfo,
  PostalCodeSearchResponse,

  // 店舗情報申請（直接）
  PostStoreDirectApplicationsResponse,
  PostStoreDirectApplicationsCountResponse,
  // 決済状態変更申請
  SettlementStateChangeApplicationUploadResult,
  CounselingSearchResponse,
  PriorPayoutShopIdsResponse,
  PriorPayoutShopIdsRequest,
  //個別相談案件
  IndividualCounselingProjectSearchRequest,
  IndividualCounselingProjectContentsRegister,
  IndividualCounselingProjectContentsRegisterResult,
  IndividualCounselingProjectRegisterResult,
  IndividualCounselingProjectRegister,
  IndividualCounselingProjectContract,
  IndividualCounselingProjectContentsItem,
  IndividualCounselingProjectContents,
  IndividualCounselingProjectContentsdata,
  // 料率
  RateAdjustmentCaseRegisterResult,
  RateAdjustmentCaseCorpInfo,
  MerchantService,
  RateAdjustmentCaseMerchantRequest,
  RateAdjustmentCaseMerchantResponse,
  RateAdjustmentCaseMerchantInfoResponse,

  //クレカ審査　申請回答
  CreditCardExaminationSearchRequest,
  CreditCardExaminationSearchResponse,
  RateAdjustmentCaseContentCode,
  RateAdjustmentCaseContentPutDeleteRequest,
  RateAdjustmentCaseContentRegisteredData,
  CreditCardExaminationApplicationFileDownloadRequest,

  // 申請状況
  ApplicationContentResponse,
  ApplicationRejectRequest,
  ApplicationFormDownload,

  // 審査内容照会
  ExaminationContentRequest,
  ExaminationContentResponse,

  //加盟店情報照会
  MerchantDetailDataSearchResponse,
  MerchantDetailDataSearchRequest,

  //加盟店情報照会（加盟店）取得API
  MerchantInfoInquiryMerchant,
  MerchantInfoInquiryMerchantRequest,
  MerchantInfoResponse,

  // 加盟店情報照会-加盟店ダウンロードAPI
  MerchantInfoInquiryDownloadRequest,

  //加盟店一覧照会
  MerchantListSearchResponse,
  MerchantListSearchRequest,

  //加盟店情報照会（店舗）取得API
  MerchantInfoInquiryStore,
  MerchantStoreSiteId,
  MerchantStoreName,
  MerchantInfoInquiryStoreRequest,
  MerchantStoreDetailDataSearchResponse,
  MerchantStoreDetailDataSearchRequest,
  existingMerchantItem,
  MerchantsSystemTabSearchResponse,
  MerchantsSystemTabSearchRequest,

  //料率更新API
  RateUpdate,

  // 審査結果取扱登録
  ExaminationResultHandlingRegistrationsGetResponse,
  ExaminationResultHandlingRegistrationsPutRequestItem,
  ExaminationResultHandlingRegistrationsPutResponse,

  // 再審査指示判定取得API
  ReexaminationOrdersResponse,

  // VM選択 遅延店子審査チェックAPI
  ReexaminationOrdersVmExaminationCheckResponse,
  ReexaminationOrdersVmExaminationCheckRequest,

  // 再審査対象選定・指示API
  ReexaminationOrdersApplicationRequestItem,
  ReexaminationOrdersApplicationResponse,

  // 審査結果判定API
  ReexaminationOrdersDecisionRequestItem,
  ReexaminationOrdersDecisionResponse,

  // 審査状況照会
  ExaminationStatusSearchResponse,
  ExaminationStatusSearchRequest,

  //金融機関マスタAPI
  FinancialInstitution,
  FinancialInstitutionBranch,

  // SSO
  OnetimePasswordResponse,
  OnetimePasswordRequest,

  // 申請
  ApplicationStatusSearchRequest,
  ApplicationStatusSearchResponse,

  //加盟店申請（直接）
  MerchantDirectApplicationResponse,

  // 個別取扱確認
  IndividualHandlingSearchRequest,
  IndividualHandlingSearchResponse,
  IndividualHandlingConfirmationResponse,
  IndividualHandlingConfirmationUpdateRequest,
  IndividualHandlingConfirmationTargetRate,

  //入金口座
  BankAccountsListSearchRequest,
  BankAccountsListSearchResponse,
  BankAccountsReferenceResponse,
  BankAccountsUpdateRequest,

  // 変換ツール
  ConversionToolResponse,
  relatedExaminationContentResponse,
  SwitchPaymentProviderResponse,

  // お知らせ一覧
  Announcement,
} from "./api-interfaces";
import { BASE_URL } from "../configs/configs";
import { addNotification } from "./error/notifications-slice";
import { Messages } from "./error/messages";
import { createQueryParameters } from "../utils/parameter";

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      isDownload?: boolean;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, isDownload }, api) => {
    const token = await Auth.currentSession().then((res) => {
      return res.getIdToken().getJwtToken();
    });
    const requestHeaders = {
      Authorization: token,
    };
    try {
      if (isDownload) {
        const result = await axios({
          url: baseUrl + url,
          method,
          data,
          params,
          responseType: "blob",
          headers: requestHeaders,
        });
        const contentDisposition = result.headers["content-disposition"];
        if (contentDisposition) {
          const isUTF8Encode = contentDisposition
            .split('"')[0]
            .includes("UTF-8");
          const headersFileName = contentDisposition.split('"')[1];
          const fileName = isUTF8Encode
            ? decodeURI(headersFileName)
            : headersFileName;
          fileDownload(result.data, fileName);
        }
        return { data: result };
      }
      const result = await axios({
        url: baseUrl + url,
        method,
        data,
        params,
        headers: requestHeaders,
      });

      //ステータスを含む時
      if (result.data.status) {
        // メッセージオブジェクトを含み、メッセージIDを含む時
        if (result?.data?.message?.messageId) {
          // メッセージIDの取得
          const messageResult = result.data.message;
          const messageId = messageResult.messageId as keyof Messages;
          let messageArgs = [];
          if (null !== messageResult.messageArgs) {
            messageArgs = messageResult.messageArgs;
          }
          // アラート処理
          api.dispatch(
            addNotification({
              msgId: messageId,
              msgArgs: messageArgs,
            })
          );
        }
      } else if (result.data.messageId) {
        // ほかflashbarを表示ケース info/success/warning
        let messageArgs = [];
        if (null !== result.data.messageArgs) {
          messageArgs = result.data.messageArgs;
        }
        api.dispatch(
          addNotification({
            msgId: result.data.messageId,
            msgArgs: messageArgs,
          })
        );
      }

      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError as AxiosError;
      let errStatus = err.response?.status;
      let msgId: keyof Messages;
      let errData = err.response?.data as ErrorData;
      let msgArgs: string[] = [];

      switch (errStatus) {
        case 400:
          msgId = "KGRERR013";
          msgArgs = [errData.messageId];
          break;
        case 403:
          msgId = "KGRERR002";
          break;
        case 404:
          msgId = "KGRERR012";
          break;
        case 409:
          msgId = "KGRERR003";
          break;
        case 503:
          msgId = "KGRERR004";
          break;
        default:
          msgId = "KGRFAT001";
          break;
      }

      api.dispatch(addNotification({ msgId: msgId, msgArgs: msgArgs }));
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

// Define a service using a base URL and expected endpoints
export const api = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({
    baseUrl: BASE_URL,
  }),
  tagTypes: ["Users", "Auth"],
  endpoints: (builder) => ({
    getGroups: builder.query<Group[], void>({
      query: () => ({ url: "groups", method: "get" }),
    }),
    getDependenceCharacters: builder.query<DependenceCharacter[], void>({
      query: () => ({ url: "masters/dependence-characters", method: "get" }),
    }),
    getDependenceCharactersDownload: builder.query<void, void>({
      query: () => ({
        url: "masters/dependence-characters/download",
        method: "get",
        isDownload: true,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getNgNames: builder.query<NgName[], void>({
      query: () => ({ url: "masters/ngnames", method: "get" }),
    }),
    getNgNamesDownload: builder.query<void, void>({
      query: () => ({
        url: "masters/ngnames/download",
        method: "get",
        isDownload: true,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getMerchantTypes: builder.query<MerchantTypeReference[], void>({
      query: () => ({
        url: "masters/merchant-types",
        method: "get",
      }),
    }),
    getMerchantType: builder.query<MerchantType, number>({
      query: (merchantTypeNo) => ({
        url: `masters/merchant-types/${merchantTypeNo}`,
        method: "get",
      }),
    }),
    postMerchantType: builder.mutation<MerchantTypeResult, MerchantTypeResist>({
      query: (data) => ({
        url: "masters/merchant-types",
        method: "post",
        data: data,
      }),
    }),
    putMerchantType: builder.mutation<
      MerchantTypeResult,
      MerchantTypeResistUpdate
    >({
      query: (data) => ({
        url: `masters/merchant-types/${data.merchantTypeNo}`,
        method: "put",
        data: data.data,
      }),
    }),
    deleteMerchantType: builder.mutation<
      StatusMessage,
      MerchantTypeResistUpdate
    >({
      query: (data) => ({
        url: `masters/merchant-types/${data.merchantTypeNo}`,
        method: "delete",
        data: data.data,
      }),
    }),
    getDivision: builder.query<Division[], string>({
      query: (kbnParentCode) => ({
        url: `masters/divisions/${kbnParentCode}`,
        method: "get",
      }),
    }),
    getCommercialMerchantType: builder.query<MerchantType, number>({
      query: (typeNo) => ({
        url: `masters/merchant-types/type-no/${typeNo}`,
        method: "get",
      }),
    }),
    getCommercialMerchantTypes: builder.query<MerchantType[], void>({
      query: () => ({
        url: "masters/merchant-types/commercial",
        method: "get",
      }),
    }),
    postDependenceCharactersUpload: builder.mutation<
      DependenceCharacterUpload,
      FormData
    >({
      query: (formData) => ({
        url: "masters/dependence-characters/upload",
        method: "post",
        data: formData,
      }),
    }),
    postDependenceCharacters: builder.mutation<
      DependenceCharacterUpdateResult,
      DependenceCharacter[]
    >({
      query: (data) => ({
        url: "masters/dependence-characters",
        method: "post",
        data: data,
      }),
    }),
    // -- start ユーザAPI --
    getUsers: builder.query<UsersSearchResponse[], UsersSearchRequest>({
      query: (searchInput) => {
        const queryParam = createQueryParameters(searchInput);
        return {
          url: `users?${queryParam}`,
          method: "get",
        };
      },
      providesTags: ["Users"],
    }),
    updateUsers: builder.mutation<Message, UsersUpdateRequest>({
      query: (data) => {
        return {
          url: "users",
          method: "PUT",
          data,
        };
      },
      invalidatesTags: ["Users"],
    }),
    deleteUsers: builder.mutation<Message, UserDeleteRequest>({
      query: (data) => {
        return {
          url: "users",
          method: "DELETE",
          data,
        };
      },
      invalidatesTags: ["Users"],
    }),
    addUser: builder.mutation<Message, Partial<UserCreateRequest>>({
      query: (data) => {
        return {
          url: "users",
          method: "post",
          data: data,
        };
      },
      invalidatesTags: ["Users"],
    }),
    updateUser: builder.mutation<Message, UserUpdateRequest>({
      query: (data) => {
        const { cognitoId, ...body } = data;

        return {
          url: `users/${cognitoId}`,
          method: "PUT",
          data: body,
        };
      },
      invalidatesTags: ["Users"],
    }),
    updateUserResendCode: builder.mutation<Message, string>({
      query: (cognitoId) => {
        return {
          url: `users/${cognitoId}/resend-code`,
          method: "PUT",
        };
      },
    }),
    updateUserReissueInitialPassword: builder.mutation<Message, string>({
      query: (cognitoId) => {
        return {
          url: `users/${cognitoId}/reissue-initial-password`,
          method: "PUT",
        };
      },
    }),
    getAuth: builder.query<AuthResponse, void>({
      query: () => {
        return {
          url: `users/auth`,
          method: "get",
        };
      },
      //　ログアウトする際にstateクリアのためのタグ
      providesTags: ["Auth"],
    }),
    issueOnetimePassword: builder.mutation<
      OnetimePasswordResponse,
      OnetimePasswordRequest
    >({
      query: (requestBody) => ({
        url: `users/onetime-password/issue`,
        method: "post",
        data: requestBody,
      }),
    }),
    // --end ユーザAPI

    getCompanyNames: builder.query<
      CompanyNamesSearchResponse[],
      CompanyNamesSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `companies/company-names?${queryParam}`,
          method: "get",
        };
      },
    }),
    getReferenceGroupNames: builder.query<
      ReferenceGroupNamesSearchResponse[],
      ReferenceGroupNamesSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `companies/reference-groups?${queryParam}`,
          method: "get",
        };
      },
    }),
    postNgNamesUpload: builder.mutation<NgNamesUpload, FormData>({
      query: (formData) => ({
        url: "masters/ngnames/upload",
        method: "post",
        data: formData,
      }),
    }),
    postNgNames: builder.mutation<NgNamesUpdateResult, NgName[]>({
      query: (data) => ({
        url: "masters/ngnames",
        method: "post",
        data: data,
      }),
    }),
    getNotices: builder.query<Notice[], void>({
      query: () => ({ url: "masters/notifications", method: "get" }),
    }),
    getNotice: builder.query<Notice, number>({
      query: (data) => ({
        url: `masters/notifications/${data}`,
        method: "get",
      }),
    }),
    putNoticeUpdate: builder.mutation<Message, NoticeUpdate>({
      query: (data) => ({
        url: `masters/notifications/${data.id}`,
        method: "put",
        data: data,
      }),
    }),
    getHoldingsInfos: builder.query<HoldingsInfo[], HoldingsSearchRequest>({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return { url: `holdings?${queryParam}`, method: "get" };
      },
    }),
    postHoldingsRegister: builder.mutation<
      HoldingsRegisterResult,
      HoldingsRegister
    >({
      query: (data) => ({
        url: "holdings",
        method: "post",
        data: data,
      }),
    }),
    getHoldingsUpdateInfo: builder.query<
      HoldingsUpdateInfo,
      string | undefined
    >({
      query: (data) => ({
        url: `holdings/company/${data}`,
        method: "get",
      }),
    }),
    getHoldingsUpdateAffiliatedStoreCompanyInfo: builder.query<
      HoldingsAffiliatedCompany[],
      string | undefined
    >({
      query: (data) => ({
        url: `holdings/affiliated-company/${data}`,
        method: "get",
      }),
    }),
    putHoldingsUpdate: builder.mutation<Message, HoldingsUpdate>({
      query: (data) => ({
        url: `holdings/company/${data.companyCode}`,
        method: "put",
        data: data,
      }),
    }),
    getHoldingsAffiliatedCompanyInfos: builder.query<
      HoldingsAffiliatedCompany[],
      HoldingsAffiliatedCompanyRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return { url: `gateways?${queryParam}`, method: "get" };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    postHoldingsAffiliatedCompanyRegister: builder.mutation<
      HoldingsRegisterResult,
      HoldingsAffiliatedCompanyRegister
    >({
      query: (data) => ({
        url: `holdings/affiliated-company/${data.companyCode}`,
        method: "post",
        data: data.holdingsAffiliatedCompany,
      }),
    }),
    deleteHoldingsContract: builder.mutation<
      Message,
      HoldingsAffiliatedCompanyRegister
    >({
      query: (data) => ({
        url: `holdings/affiliated-company/${data.companyCode}`,
        method: "delete",
        data: data.holdingsAffiliatedCompany,
      }),
    }),
    getGwCompanies: builder.query<
      GatewaySearchResponse[],
      GatewaySearchRequest | undefined
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return { url: `gateways?${queryParam}`, method: "get" };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getGwCompaniesDownload: builder.query<void, GatewaySearchRequest>({
      // FIXME:他のパラメータ積む。ただ、最初は検索条件ないかも？
      query: (params) => {
        const paramsStr = "";
        return {
          url: `gw/download?${paramsStr}`,
          method: "get",
          isDownload: true,
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    postGatewayCompaniesContracts: builder.mutation<
      GatewayCompaniesContractsResult,
      GatewayCompaniesContracts
    >({
      query: (data) => ({
        url: `gateways/${data.gwCompanyCode}/gw-contracts`,
        method: "post",
        data: data,
      }),
    }),
    postGatewaysRegister: builder.mutation<
      GatewayRegisterResult,
      GatewayRegister
    >({
      query: (data) => ({
        url: "gateways",
        method: "post",
        data: data,
      }),
    }),
    getGatewayCompaniesContractsUpdateInfo: builder.query<
      GatewayCompaniesContractsUpdateInfo,
      GatewayCompaniesContractsInfoItem
    >({
      query: (data) => ({
        url: `gateways/${data.gwCompanyCode}/gw-contracts/${data.gatewayNo}`,
        method: "get",
      }),
    }),
    putGatewayCompaniesContractsUpdate: builder.mutation<
      StatusMessage,
      GatewayCompaniesContractsUpdateInfo
    >({
      query: (data) => ({
        url: `gateways/${data.data.gwCompanyCode}/gw-contracts/${data.gatewayNo}`,
        method: "put",
        data: data.data,
      }),
    }),
    getGwCompany: builder.query<GatewayRegister, string>({
      query: (data) => {
        return { url: `gateways/${data}`, method: "get" };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getGwCompanyContracts: builder.query<GatewayContract[], string>({
      query: (data) => {
        return { url: `gateways/${data}/gw-contracts`, method: "get" };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    putGatewaysUpdate: builder.mutation<GatewayUpdateResult, GatewayUpdate>({
      query: (data) => ({
        url: `gateways/${data.gwCompanyCode}`,
        method: "put",
        data: data.data,
      }),
    }),

    getGatewayCompaniesInfos: builder.query<GatewayCompaniesInfo, string>({
      query: (companiesData) => ({
        url: `gateways/${companiesData}`,
        method: "get",
      }),
    }),

    getTouristIndustries: builder.query<TouristIndustries[], void>({
      query: () => ({
        url: `masters/tourist-industry-registrant`,
        method: "get",
      }),
    }),
    getTouristIndustriesDownload: builder.query<void, void>({
      query: () => ({
        url: "masters/tourist-industry-registrant/download",
        method: "get",
        isDownload: true,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    postTouristIndustriesUpload: builder.mutation<
      TouristIndustriesUpload,
      FormData
    >({
      query: (formData) => ({
        url: "masters/tourist-industry-registrant/upload",
        method: "post",
        data: formData,
      }),
    }),
    postMerchantsInclusionApplicationUpload: builder.mutation<
      MerchantsInclusionApplicationUpload,
      FormData
    >({
      query: (formData) => ({
        url: "merchant-applications/merchant-inclusion-applications",
        method: "post",
        data: formData,
      }),
    }),
    postCompanyCodeCheck: builder.mutation<CompanyCodeCheck, FormData>({
      query: (formData) => ({
        url: "merchant-applications/company-code-check",
        method: "post",
        data: formData,
      }),
    }),
    postMerchantAlternativeDirectApplication: builder.mutation<
      MerchantAlternativeDirectApplication,
      FormData
    >({
      query: (formData) => ({
        url: "merchant-applications/merchant-alternative-direct-applications",
        method: "post",
        data: formData,
      }),
    }),
    postSettlementStateChangeApplicationUpload: builder.mutation<
      SettlementStateChangeApplicationUploadResult,
      FormData
    >({
      query: (data) => {
        return {
          url: "settlement-state-change-application",
          method: "post",
          data: data,
        };
      },
    }),
    postMerchantsDirectApplicationRegister: builder.mutation<
      MerchantsDirectApplicationResponse,
      MerchantsDirectApplicationRequest
    >({
      query: (data) => ({
        url: "merchant-applications/merchant-direct-applications",
        method: "post",
        data: data.data,
      }),
    }),
    postTouristIndustries: builder.mutation<
      TouristIndustriesUpdateResult,
      TouristIndustriesItem[]
    >({
      query: (data) => ({
        url: "masters/tourist-industry-registrant",
        method: "post",
        data: data,
      }),
    }),
    getIndustryConversion: builder.query<
      IndustryConversionReference[],
      IndustryConversionRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `masters/industry-conversions?${queryParam}`,
          method: "get",
        };
      },
    }),
    getIndustryAfterConversionCode: builder.query<CommercialIndustries[], void>(
      {
        query: () => ({
          url: `masters/commercial-industries`,
          method: "get",
        }),
      }
    ),
    getCommercialIndustries: builder.query<CommercialIndustries[], void>({
      query: () => ({
        url: `masters/commercial-industries`,
        method: "get",
      }),
    }),
    postIndustryConversions: builder.mutation<
      IndustryConversionsResult,
      IndustryConversionsRequest
    >({
      query: (data) => ({
        url: "masters/industry-conversions",
        method: "post",
        data: data,
      }),
    }),
    getIndustryConversionUpdate: builder.query<IndustryConversion, number>({
      query: (conversionRuleNo) => ({
        url: `masters/industry-conversions/${conversionRuleNo}`,
        method: "get",
      }),
    }),
    getApprovedIndustryConversion: builder.query<IndustryConversion, number>({
      query: (ruleNo) => ({
        url: `masters/industry-conversions/rule-no/${ruleNo}`,
        method: "get",
      }),
    }),
    putIndustryConversion: builder.mutation<
      IndustryConversionsResult,
      IndustryConversionsUpdate
    >({
      query: (data) => ({
        url: `masters/industry-conversions/${data.conversionRuleNo}`,
        method: "put",
        data: data.data,
      }),
    }),
    deleteIndustryConversion: builder.mutation<
      StatusMessage,
      IndustryConversionsUpdate
    >({
      query: (data) => ({
        url: `masters/industry-conversions/${data.conversionRuleNo}`,
        method: "delete",
        data: data.data,
      }),
    }),
    // 店舗申請（直接）申請内容登録API
    postStoreDirectApplications: builder.mutation<
      PostStoreDirectApplicationsResponse,
      FormData
    >({
      query: (data) => ({
        url: "store-applications",
        method: "post",
        data,
      }),
    }),
    // 店舗申請（直接）全量申請閉店数確認API
    postStoreDirectApplicationsCount: builder.mutation<
      PostStoreDirectApplicationsCountResponse,
      FormData
    >({
      query: (data) => ({
        url: "store-applications/count",
        method: "post",
        data,
      }),
    }),
    // 店舗申請（直接）全量申請内容登録API
    postStoreDirectApplicationsAll: builder.mutation<
      PostStoreDirectApplicationsResponse,
      FormData
    >({
      query: (data) => ({
        url: "store-applications/all",
        method: "post",
        data,
      }),
    }),
    //  料率調整案件一覧
    getRateAdjustmentCases: builder.query<
      RateAdjustmentCaseSearchResponse[],
      RateAdjustmentCaseSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return { url: `rate-adjustment-case?${queryParam}`, method: "get" };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 料率調整案件 加盟店登録
    postRateAdjustmentCaseMerchantRegister: builder.mutation<
      RateAdjustmentCaseMerchantResponse,
      RateAdjustmentCaseMerchantRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/merchant/${data.rateAdjustmentCaseNo}`,
        method: "post",
        data: data,
      }),
    }),

    // 料率調整案件 加盟店情報取得
    getRateAdjustmentCaseMerchantInfo: builder.query<
      RateAdjustmentCaseMerchantInfoResponse,
      RateAdjustmentCaseMerchantRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/merchant/${data.rateAdjustmentCaseNo}/${data.merchantBranchNo}`,
        method: "get",
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 料率調整案件 加盟店更新
    putRateAdjustmentCaseMerchantUpdate: builder.mutation<
      RateAdjustmentCaseMerchantResponse,
      RateAdjustmentCaseMerchantRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/merchant/${data.rateAdjustmentCaseNo}/${data.merchantBranchNo}`,
        method: "put",
        data: data,
      }),
    }),
    // 料率調整案件 加盟店削除
    deleteRateAdjustmentCaseMerchant: builder.mutation<
      RateAdjustmentCaseMerchantResponse,
      RateAdjustmentCaseMerchantRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/merchant/${data.rateAdjustmentCaseNo}/${data.merchantBranchNo}`,
        method: "delete",
        data: data,
      }),
    }),
    //料率調整案件加盟店調整内容一覧取得
    getRateAdjustmentCaseMerchantContents: builder.query<
      RateAdjustmentCaseSearchResponse[],
      RateAdjustmentCaseMerchantRequest
    >({
      query: (data) => {
        return {
          url: `rate-adjustment-case/merchant/contents/${data.rateAdjustmentCaseNo}/${data.merchantBranchNo}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // クレカ加盟店番号登録API
    postPriorPayoutCreditCardMerchantNumbers: builder.mutation<
      PriorPayoutCreditCardMerchantNumbersResponse,
      PriorPayoutCreditCardMerchantNumbersRequest
    >({
      query: (data) => ({
        url: "prior-payout/credit-card-merchant-numbers",
        method: "post",
        data: data,
      }),
    }),
    // クレカ審査依頼先取得API
    getCreditCardExaminations: builder.query<
      CreditCardExamination[],
      CreditCardExaminationsRequest
    >({
      query: (data) => ({
        url: `masters/credit-cards/credit-card-examinations/${data.priorPayoutTarget}`,
        method: "get",
      }),
    }),
    // ShopID登録API
    postPriorPayoutShopIds: builder.mutation<
      PriorPayoutShopIdsResponse,
      PriorPayoutShopIdsRequest[]
    >({
      query: (data) => ({
        url: "prior-payout/shop-ids",
        method: "post",
        data: data,
      }),
    }),
    //個別相談案件登録API
    postIndividualCounselingProjectRegister: builder.mutation<
      IndividualCounselingProjectRegisterResult,
      IndividualCounselingProjectRegister
    >({
      query: (data) => ({
        url: "individual-counseling-projects",
        method: "post",
        data: data,
      }),
    }),
    //個別相談案件事業者取得API
    getIndividualCounselingProject: builder.query<
      IndividualCounselingProjectRegister[],
      string
    >({
      query: (data) => {
        return {
          url: `individual-counseling-projects/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    //料率調整案件調整内容登録API
    postRateAdjustmentCaseContent: builder.mutation<
      RateAdjustmentCaseContentResponse,
      RateAdjustmentCaseContentRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/contents/${data.rateAdjustmentCaseNo}/${data.merchantBranchNo}`,
        method: "post",
        data: data.data,
      }),
    }),

    //料率調整案件調整内容取得API
    getRateAdjustmentCaseContent: builder.query<
      RateAdjustmentCaseContentRegisteredData,
      RateAdjustmentCaseContentCode
    >({
      query: (data) => {
        return {
          url: `rate-adjustment-case/contents/${data.rateAdjustmentCaseNo}/${data.merchantBranchNo}/${data.adjustmentBranchNo}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    //料率調整案件調整内容更新API
    putRateAdjustmentCaseContent: builder.mutation<
      RateAdjustmentCaseContentResponse,
      RateAdjustmentCaseContentPutDeleteRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/contents/${data.code.rateAdjustmentCaseNo}/${data.code.merchantBranchNo}/${data.code.adjustmentBranchNo}`,
        method: "put",
        data: data.data,
      }),
    }),

    //料率調整案件調整内容削除API(仮)
    deleteRateRateAdjustmentCaseContent: builder.mutation<
      Message,
      RateAdjustmentCaseContentPutDeleteRequest
    >({
      query: (data) => ({
        url: `rate-adjustment-case/contents/${data.code.rateAdjustmentCaseNo}/${data.code.merchantBranchNo}/${data.code.adjustmentBranchNo}`,
        method: "delete",
        data: data.data,
      }),
    }),

    //個別相談案件相談内容一覧取得API
    getIndividualCounselingProjectContractsList: builder.query<
      IndividualCounselingProjectContract[],
      string
    >({
      query: (data) => {
        return {
          url: `individual-counseling-projects/list/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // クレカ審査申請回答登録一覧取得API
    getCreditCardExaminationFile: builder.query<
      CreditCardExaminationSearchResponse[],
      CreditCardExaminationSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `credit-card-examination-file?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 審査申請ファイルダウンロードAPI
    getApplicationFileDownload: builder.query<
      void,
      CreditCardExaminationApplicationFileDownloadRequest
    >({
      query: (data) => ({
        url: `credit-card-examination-file/application-file/download`,
        method: "GET",
        isDownload: true,
        params: data,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 審査申請回答ファイルダウンロードAPI
    getResultFileDownload: builder.query<
      void,
      CreditCardExaminationApplicationFileDownloadRequest
    >({
      query: (data) => ({
        url: `credit-card-examination-file/result-file/download`,
        method: "GET",
        isDownload: true,
        params: data,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    //クレカ審査申請回答登録API
    postCreditCardExaminationFile: builder.mutation<StatusMessage, FormData>({
      query: (formData) => ({
        url: "credit-card-examination-file",
        method: "post",
        data: formData,
      }),
    }),

    //個別相談案件相談内容登録API
    postIndividualCounselingProjectContentsRegister: builder.mutation<
      IndividualCounselingProjectContentsRegisterResult,
      IndividualCounselingProjectContentsRegister
    >({
      query: (data) => ({
        url: `individual-counseling-projects/${data.individualConsultationNo}`,
        method: "post",
        data: data,
      }),
    }),

    //個別相談案件相談内容更新API
    putIndividualCounselingProjectContentsUpdate: builder.mutation<
      StatusMessage,
      IndividualCounselingProjectContentsdata
    >({
      query: (data) => ({
        url: `individual-counseling-projects/${data.code.individualConsultationNo}/${data.code.individualConsultationBranchNo}`,
        method: "put",
        data: data.data,
      }),
    }),
    //個別相談案件相談内容取得API
    getIndividualCounselingProjectContents: builder.query<
      IndividualCounselingProjectContents,
      IndividualCounselingProjectContentsItem
    >({
      query: (data) => {
        return {
          url: `individual-counseling-projects/${data.individualConsultationNo}/${data.individualConsultationBranchNo}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    //料率調整案件情報取得
    getRateAdjustmentCaseCorpList: builder.query<
      RateAdjustmentCaseCorpInfo[],
      string
    >({
      query: (data) => {
        return {
          url: `rate-adjustment-case/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    //料率調整案件加盟店交渉履歴一覧取得
    getRateAdjustmentCaseMerchantsList: builder.query<
      MerchantService[],
      string
    >({
      query: (data) => {
        return {
          url: `rate-adjustment-case/merchant/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    //料率調整案件一覧ダウンロード
    getRateAdjustmentCaseDownload: builder.query<
      void,
      RateAdjustmentCaseSearchRequest
    >({
      query: (data) => {
        const searchParams = createQueryParameters(data);
        return {
          url: `rate-adjustment-case/download?${searchParams}`,
          method: "get",
          isDownload: true,
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 加盟店情報照会－加盟店詳細情報取得API
    getMerchantDetailData: builder.query<
      MerchantDetailDataSearchResponse,
      MerchantDetailDataSearchRequest
    >({
      query: (data) => ({
        url: `merchants/detail/${data.cpid}`,
        method: "get",
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 加盟店情報照会－店舗詳細情報APIレスポンス
    getMerchantStoreDetailData: builder.query<
      MerchantStoreDetailDataSearchResponse,
      MerchantStoreDetailDataSearchRequest
    >({
      query: (data) => ({
        url: `merchants/stores/detail/${data.storeNo}`,
        method: "get",
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getMerchantInfoResponse: builder.query<
      MerchantInfoResponse,
      string | undefined
    >({
      query: (data) => {
        return {
          url: `merchants/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 加盟店一覧取得
    getMerchantList: builder.query<
      MerchantListSearchResponse[],
      MerchantListSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `merchants-search?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // システムタブ
    getMerchantsSystemTab: builder.query<
      MerchantsSystemTabSearchResponse,
      MerchantsSystemTabSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `merchants/system-config?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // 加盟店一覧加盟店ダウンロード
    getMerchantDownload: builder.query<void, MerchantListSearchRequest>({
      query: (data) => ({
        url: "merchants/download/merchants",
        method: "get",
        params: data,
        isDownload: true,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 加盟店一覧店舗ダウンロード
    getMerchantStoreDownload: builder.query<void, MerchantListSearchRequest>({
      query: (data) => ({
        url: "merchants/download/stores",
        method: "get",
        params: data,
        isDownload: true,
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // 加盟店情報照会店舗ダウンロード
    getMerchantStoreListDownload: builder.query<
      void,
      MerchantInfoInquiryStoreRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        const companyCode = data.companyCode;
        return {
          url: `merchants/stores/download/${companyCode}?${queryParam}`,
          method: "get",
          isDownload: true,
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // 加盟店状況照会加盟店ダウンロード
    getMerchantMerchantsDownload: builder.query<
      void,
      MerchantInfoInquiryDownloadRequest
    >({
      query: (data) => {
        const searchParams = createQueryParameters(data.search);
        const companyCode = data.companyCode;
        const queryParam = `companyCode=${companyCode}&${searchParams}`;
        return {
          url: `merchants/merchants/download/${companyCode}?${queryParam}`,
          method: "get",
          isDownload: true,
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    //審査状況照会取得
    getExaminationStatus: builder.query<
      ExaminationStatusSearchResponse[],
      ExaminationStatusSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `examination-status-inquiries?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // 共通
    getRoles: builder.query<CompanyTypeRole[], void>({
      query: () => ({
        url: "system-masters/roles",
        method: "get",
      }),
    }),
    getCodeList: builder.query<Object, void>({
      query: () => ({
        url: "system-masters/codelist",
        method: "get",
      }),
      // 返却値の形を変換
      transformResponse: (response: CodeList[]) => {
        let data = {};
        response.forEach((codelist) => {
          const key = codelist.codeType;
          const value = codelist.codeGroup;
          data = { ...data, [key]: value };
        });
        return data;
      },
    }),
    getApplicationForms: builder.query<ApplicationForms[], void>({
      query: (data) => ({
        url: `masters/application-forms`,
        method: "get",
      }),
    }),
    getCorpInfoByCorpNum: builder.query<CorpInfo, string>({
      query: (data) => {
        return {
          url: `commons/corporate-number-search/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getAddressByPostalCode: builder.query<PostalCodeSearchResponse, string>({
      query: (data) => {
        return {
          url: `commons/postal-code-search/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    getCounselingList: builder.query<
      CounselingSearchResponse[],
      IndividualCounselingProjectSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `individual-counseling-projects?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 包括事業者取得API
    getComprehensiveCompanies: builder.query<
      ComprehensiveCompanySearchResponse[],
      ComprehensiveCompanySearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `companies/comprehensive-companies?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 直接申請事業者と紐づく店舗情報取込単位一覧取得API
    getDirApplicantCompanies: builder.query<DirectCompanyResponse[], void>({
      query: () => {
        return {
          url: "companies/direct",
          method: "get",
        };
      },
    }),
    postRateAdjustmentCaseRegister: builder.mutation<
      RateAdjustmentCaseRegisterResult,
      RateAdjustmentCaseCorpInfo
    >({
      query: (data) => ({
        url: "rate-adjustment-case",
        method: "post",
        data: data,
      }),
    }),
    // 申請内容取得API
    getApplicationContent: builder.query<ApplicationContentResponse, string>({
      query: (data) => {
        return {
          url: `applications/${data}`,
          method: "get",
        };
      },
    }),
    // 入金口座情報取得API
    getBankAccountsReference: builder.query<
      BankAccountsReferenceResponse,
      string
    >({
      query: (companyContractBankAccountNo) => ({
        url: `bank-accounts/${companyContractBankAccountNo}`,
        method: "get",
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 入金口座情報更新API
    putBankAccountsUpdate: builder.mutation<Message, BankAccountsUpdateRequest>(
      {
        query: (data) => ({
          url: `bank-accounts/${data.companyContractBankAccountNo}`,
          method: "put",
          data,
        }),
      }
    ),
    // 申請情報更新API
    putApplication: builder.mutation<StatusMessage, string>({
      query: (appNo) => ({
        url: `applications/${appNo}`,
        method: "put",
      }),
    }),
    // 申請差戻API
    putApplicationReject: builder.mutation<
      StatusMessage,
      ApplicationRejectRequest
    >({
      query: (data) => {
        const { applicationNo, ...body } = data;
        return {
          url: `applications/${applicationNo}/reject`,
          method: "put",
          data: body,
        };
      },
    }),
    //  審査内容照会
    getExaminationContent: builder.query<
      ExaminationContentResponse,
      ExaminationContentRequest
    >({
      query: ({ examinationApplicationNo }) => ({
        url: `examination-content/${examinationApplicationNo}`,
        method: "GET",
      }),
    }),
    getRelatedExaminationContent: builder.query<
      relatedExaminationContentResponse[],
      ExaminationContentRequest
    >({
      query: ({ examinationApplicationNo }) => ({
        url: `examination-content/${examinationApplicationNo}/related-examination-list`,
        method: "GET",
      }),
    }),

    //  加盟店情報照会（加盟店）
    getMerchantInfoInquiryMerchant: builder.query<
      MerchantInfoInquiryMerchant[],
      MerchantInfoInquiryMerchantRequest
    >({
      query: ({ companyCode, search }) => {
        const queryParam = createQueryParameters(search);
        return {
          url: `merchants/merchants/${companyCode}?${queryParam}`,
          method: "GET",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    //  料率更新
    putRateUpdate: builder.mutation<Message, RateUpdate>({
      query: (data) => ({
        url: `merchants/rate-update`,
        method: "put",
        data,
      }),
    }),
    //  加盟店情報照会（加盟店検証サイトID）
    getMerchantInfoInquiryMerchantSiteId: builder.query<
      MerchantInfoInquiryMerchant[],
      string
    >({
      query: (data) => {
        return {
          url: `merchants/merchants/all/${data}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    //  加盟店情報照会（店舗）
    getMerchantInfoInquiryStore: builder.query<
      MerchantInfoInquiryStore[],
      MerchantInfoInquiryStoreRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        const companyCode = data.companyCode;
        return {
          url: `merchants/stores/${companyCode}?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 申請状況一覧取得API
    getApplicationStatus: builder.query<
      ApplicationStatusSearchResponse[],
      ApplicationStatusSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `applications?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 申請状況照会ダウンロードAPI
    getDownloadApplication: builder.query<
      ApplicationFormDownload,
      ApplicationStatusSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `applications/download/file?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
    // 加盟店情報照会（店舗）サイトID取得
    getMerchantStoreSiteId: builder.query<MerchantStoreSiteId[], string>({
      query: (data) => ({
        url: `merchants/stores/site-id/${data}`,
        method: "get",
      }),
    }),
    // 加盟店情報照会（店舗）加盟店名取得
    getMerchantStoreStoreName: builder.query<MerchantStoreName[], string>({
      query: (data) => ({
        url: `merchants/stores/merchant-name/${data}`,
        method: "get",
      }),
    }),
    getExaminationResultHandlingRegistrations: builder.query<
      ExaminationResultHandlingRegistrationsGetResponse,
      string
    >({
      query: (examinationApplicationNo) => ({
        url: `examination-result-handling-registrations/${examinationApplicationNo}`,
        method: "GET",
      }),
    }),
    putExaminationResultHandlingRegistrations: builder.mutation<
      ExaminationResultHandlingRegistrationsPutResponse,
      ExaminationResultHandlingRegistrationsPutRequestItem
    >({
      query: ({ examinationApplicationNo, data }) => ({
        url: `examination-result-handling-registrations/${examinationApplicationNo}`,
        method: "PUT",
        data,
      }),
    }),
    getReexaminationOrders: builder.query<ReexaminationOrdersResponse, string>({
      query: (examinationApplicationNo) => ({
        url: `reexamination-orders/${examinationApplicationNo}`,
        method: "GET",
      }),
    }),
    getReexaminationOrdersVmExaminationCheck: builder.query<
      ReexaminationOrdersVmExaminationCheckResponse,
      ReexaminationOrdersVmExaminationCheckRequest
    >({
      query: ({ examinationApplicationNo, orderTargetCode }) => ({
        url: `reexamination-orders/vm-examination-check/${examinationApplicationNo}/${orderTargetCode}`,
        method: "get",
      }),
    }),
    putReexaminationOrdersApplication: builder.mutation<
      ReexaminationOrdersApplicationResponse,
      ReexaminationOrdersApplicationRequestItem
    >({
      query: ({ examinationApplicationNo, data }) => ({
        url: `reexamination-orders/application/${examinationApplicationNo}`,
        method: "PUT",
        data,
      }),
    }),
    putReexaminationOrdersDecision: builder.mutation<
      ReexaminationOrdersDecisionResponse,
      ReexaminationOrdersDecisionRequestItem
    >({
      query: ({ examinationApplicationNo, data }) => ({
        url: `reexamination-orders/decision/${examinationApplicationNo}`,
        method: "PUT",
        data,
      }),
    }),
    // 金融機関母体名全取得
    getFinancialInstitutionAll: builder.query<FinancialInstitution[], void>({
      query: () => ({
        url: `masters/financial-institution`,
        method: "get",
      }),
    }),
    // 金融機関支店名全取得
    getFinancialInstitutionBranch: builder.query<
      FinancialInstitutionBranch[],
      string
    >({
      query: (data) => ({
        url: `masters/financial-institution/${data}`,
        method: "get",
      }),
    }),
    // 加盟店申請（直接）取得
    getMerchantDirectApplication: builder.query<
      MerchantDirectApplicationResponse,
      number
    >({
      query: (receiptNumber) => ({
        url: `merchant-applications/merchant-direct-applications/${receiptNumber}`,
        method: "get",
      }),
    }),

    // 既存加盟店全取得
    getExistingMerchant: builder.query<existingMerchantItem[], string>({
      query: (data) => ({
        url: `merchants/merchants-info/${data}`,
        method: "get",
      }),
    }),

    // 個別取扱確一覧取得API
    getIndividualHandlingConfirmation: builder.query<
      IndividualHandlingSearchResponse[],
      IndividualHandlingSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `individual-handling-projects?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // 個別取扱確認更新内容取得API
    getIndividualHandlingConfirmationTarget: builder.query<
      IndividualHandlingConfirmationResponse,
      string
    >({
      query: (applicationNo) => ({
        url: `individual-handling-projects/confirmation-target/${applicationNo}`,
        method: "get",
      }),
    }),

    // 個別取扱確認更新API
    putIndividualHandlingConfirmationTargetUpdate: builder.mutation<
      Message,
      IndividualHandlingConfirmationUpdateRequest
    >({
      query: (data) => ({
        url: `individual-handling-projects/confirmation-target`,
        method: "put",
        data,
      }),
    }),
    //変換ツールアップロードAPI
    postConversionTool: builder.mutation<ConversionToolResponse, FormData>({
      query: (formData) => ({
        url: "conversion-tool",
        method: "post",
        data: formData,
      }),
    }),

    // 個別取扱確認料率カテゴリ取得API
    getIndividualHandlingConfirmationTargetRate: builder.query<
      IndividualHandlingConfirmationTargetRate[],
      void
    >({
      query: () => ({
        url: `individual-handling-projects/confirmation-target-rate`,
        method: "get",
      }),
    }),

    // 加盟店一覧取得
    getBankAccountsList: builder.query<
      BankAccountsListSearchResponse[],
      BankAccountsListSearchRequest
    >({
      query: (data) => {
        const queryParam = createQueryParameters(data);
        return {
          url: `bank-accounts?${queryParam}`,
          method: "get",
        };
      },
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),

    // 決済事業者切替
    postSwitchPaymentProvider: builder.mutation<
      SwitchPaymentProviderResponse,
      FormData
    >({
      query: (formData) => ({
        url: "switch-payment-provider",
        method: "post",
        data: formData,
      }),
    }),
    // お知らせ一覧
    getAnnouncements: builder.query<Announcement[], void>({
      query: () => ({
        url: "announcements",
        method: "get",
      }),
      // キャッシュ無効
      keepUnusedDataFor: 0,
    }),
  }),
});

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const {
  useGetGroupsQuery,
  // dependenceCharacters
  useGetDependenceCharactersQuery,
  useLazyGetDependenceCharactersDownloadQuery,
  usePostDependenceCharactersMutation,
  usePostDependenceCharactersUploadMutation,

  //加盟店種別
  useGetMerchantTypesQuery,
  useGetMerchantTypeQuery,
  usePostMerchantTypeMutation,
  usePutMerchantTypeMutation,
  useDeleteMerchantTypeMutation,
  useGetCommercialMerchantTypeQuery,
  useGetCommercialMerchantTypesQuery,
  useGetDivisionQuery,

  // ngNames
  useGetNgNamesQuery,
  useLazyGetNgNamesDownloadQuery,
  usePostNgNamesMutation,
  usePostNgNamesUploadMutation,

  // users
  useGetUsersQuery,
  useAddUserMutation,
  useUpdateUserMutation,
  useUpdateUsersMutation,
  useDeleteUsersMutation,
  useUpdateUserResendCodeMutation,
  useUpdateUserReissueInitialPasswordMutation,
  useGetAuthQuery,
  useIssueOnetimePasswordMutation,
  useGetCompanyNamesQuery,
  useGetReferenceGroupNamesQuery,

  // 店舗情報申請（直接）
  usePostStoreDirectApplicationsMutation,
  usePostStoreDirectApplicationsCountMutation,
  usePostStoreDirectApplicationsAllMutation,

  // 共通
  useGetRolesQuery,
  useGetCodeListQuery,
  useGetComprehensiveCompaniesQuery,
  useGetDirApplicantCompaniesQuery,
  useGetCorpInfoByCorpNumQuery,
  useGetAddressByPostalCodeQuery,

  // notice
  useGetNoticesQuery,
  useGetNoticeQuery,
  usePutNoticeUpdateMutation,

  // 料率
  useGetRateAdjustmentCasesQuery,
  usePostRateAdjustmentCaseRegisterMutation,
  usePostRateAdjustmentCaseContentMutation,
  useGetRateAdjustmentCaseCorpListQuery,
  useGetRateAdjustmentCaseMerchantsListQuery,
  usePostRateAdjustmentCaseMerchantRegisterMutation,
  useGetRateAdjustmentCaseContentQuery,
  usePutRateAdjustmentCaseContentMutation,
  useDeleteRateRateAdjustmentCaseContentMutation,
  useGetRateAdjustmentCaseMerchantInfoQuery,
  usePutRateAdjustmentCaseMerchantUpdateMutation,
  useDeleteRateAdjustmentCaseMerchantMutation,
  useGetRateAdjustmentCaseMerchantContentsQuery,
  useLazyGetRateAdjustmentCaseDownloadQuery,
  // ホールディングス
  useGetHoldingsInfosQuery,
  usePostHoldingsRegisterMutation,
  useGetHoldingsUpdateInfoQuery,
  useGetHoldingsUpdateAffiliatedStoreCompanyInfoQuery,
  usePutHoldingsUpdateMutation,
  useGetHoldingsAffiliatedCompanyInfosQuery,
  usePostHoldingsAffiliatedCompanyRegisterMutation,
  useDeleteHoldingsContractMutation,
  useGetGwCompaniesQuery,
  useGetGwCompaniesDownloadQuery,
  usePostGatewaysRegisterMutation,
  usePostGatewayCompaniesContractsMutation,
  useGetGatewayCompaniesContractsUpdateInfoQuery,
  usePutGatewayCompaniesContractsUpdateMutation,
  useGetGatewayCompaniesInfosQuery,
  useGetGwCompanyQuery,
  useGetGwCompanyContractsQuery,
  usePutGatewaysUpdateMutation,
  useGetTouristIndustriesQuery,
  useLazyGetTouristIndustriesDownloadQuery,
  usePostTouristIndustriesUploadMutation,
  usePostTouristIndustriesMutation,
  usePostMerchantsInclusionApplicationUploadMutation,
  usePostMerchantAlternativeDirectApplicationMutation,
  usePostSettlementStateChangeApplicationUploadMutation,
  usePostMerchantsDirectApplicationRegisterMutation,
  useGetCommercialIndustriesQuery,
  useGetIndustryAfterConversionCodeQuery,
  usePostIndustryConversionsMutation,
  useGetIndustryConversionQuery,
  useGetApprovedIndustryConversionQuery,
  usePutIndustryConversionMutation,
  useDeleteIndustryConversionMutation,
  useGetIndustryConversionUpdateQuery,
  useGetApplicationFormsQuery,
  usePostPriorPayoutCreditCardMerchantNumbersMutation,
  useGetCreditCardExaminationsQuery,
  useGetCounselingListQuery,
  usePostPriorPayoutShopIdsMutation,
  usePostCompanyCodeCheckMutation,

  //個別相談案件
  usePostIndividualCounselingProjectContentsRegisterMutation,
  usePostIndividualCounselingProjectRegisterMutation,
  useGetIndividualCounselingProjectQuery,
  useGetIndividualCounselingProjectContractsListQuery,
  usePutIndividualCounselingProjectContentsUpdateMutation,
  useGetIndividualCounselingProjectContentsQuery,

  //クレカ審査 審査申請
  useGetCreditCardExaminationFileQuery,
  usePostCreditCardExaminationFileMutation,
  useGetApplicationFileDownloadQuery,
  useGetResultFileDownloadQuery,

  //申請状況
  useGetApplicationContentQuery,
  usePutApplicationMutation,
  usePutApplicationRejectMutation,
  useLazyGetDownloadApplicationQuery,

  //入金口座情報
  useGetBankAccountsReferenceQuery,
  usePutBankAccountsUpdateMutation,

  //審査状況照会
  useGetExaminationStatusQuery,

  // 審査内容照会
  useGetExaminationContentQuery,
  useGetRelatedExaminationContentQuery,

  //加盟店情報照会
  useGetMerchantsSystemTabQuery,
  useGetMerchantDetailDataQuery,
  useGetMerchantInfoInquiryMerchantQuery,
  useGetMerchantInfoInquiryMerchantSiteIdQuery,
  //加盟店情報照会
  useGetMerchantInfoResponseQuery,
  useGetMerchantListQuery,
  useLazyGetMerchantDownloadQuery,
  useLazyGetMerchantStoreListDownloadQuery,
  useGetMerchantStoreDetailDataQuery,
  //料率更新
  usePutRateUpdateMutation,
  // 加盟店状況照会店舗ダウンロード
  useLazyGetMerchantStoreDownloadQuery,
  // 加盟店状況照会加盟店ダウンロード
  useLazyGetMerchantMerchantsDownloadQuery,
  // 加盟店情報照会（店舗）
  useGetMerchantInfoInquiryStoreQuery,
  useGetMerchantStoreSiteIdQuery,
  useGetMerchantStoreStoreNameQuery,
  useGetExistingMerchantQuery,

  // 審査結果取扱登録
  useGetExaminationResultHandlingRegistrationsQuery,
  usePutExaminationResultHandlingRegistrationsMutation,

  //金融機関マスタ
  useGetFinancialInstitutionAllQuery,
  useGetFinancialInstitutionBranchQuery,

  // 再審査指示判定
  useGetReexaminationOrdersQuery,
  useLazyGetReexaminationOrdersVmExaminationCheckQuery,
  usePutReexaminationOrdersApplicationMutation,
  usePutReexaminationOrdersDecisionMutation,
  //　申請
  useGetApplicationStatusQuery,

  //加盟店申請（直接）
  useGetMerchantDirectApplicationQuery,

  //変換ツール
  usePostConversionToolMutation,

  // 個別取扱
  useGetIndividualHandlingConfirmationQuery,
  useGetIndividualHandlingConfirmationTargetQuery,
  usePutIndividualHandlingConfirmationTargetUpdateMutation,
  useGetIndividualHandlingConfirmationTargetRateQuery,

  // 入金口座
  useGetBankAccountsListQuery,

  // 決済事業者切替
  usePostSwitchPaymentProviderMutation,

  // お知らせ一覧
  useGetAnnouncementsQuery,
} = api;
